<template>

    <div v-if="panelPreShowView" class="presenter-panel">

        <div v-if="!displayQRCode">
            <br>
            <br>
            <br>
            <br>
            <h1>PhotoProv</h1>
            <h3>Real Photographs, Made up Stories</h3>
        </div>

        <div v-if="displayQRCode">
            Use the PhotoProv web page to upload photos to be used in the show.
            <br>
            <QRCode :audience-url="this.currentShowObj.audienceAppUrl" :show-url-beneath="false" :qr-code-size="600" />
            <span v-if="!fullScreenMode" style="color:#555">{{ this.showDescription }}</span>
            <br>
            <v-btn v-if="!fullScreenMode" @click="goFullscreen" color="secondary">Go Fullscreen</v-btn>
        </div>
    </div>

    <div v-if="panelForcedImageView" class="presenter-panel">
        <div :class="'photo-container'">
            <img class="fullscreen-photo" :src="forcedPhotoUrl" />
        </div>
    </div>

    <div v-if="panelPhotoSelectView">

        <div v-if="rotationInResetState" class="photo-container">
            <div class="rotation-qmarks-div" style="padding-left:80px;">
                <span class="logoText">PHOTOPROV</span>
            </div>
        </div>

        <div v-if="!rotationInResetState">
            <!-- note: using class to show/hide images instead of v-if to get rid of choppy image loading -->
            <div v-for="(photo, index) in photos" :key="index"
                :class="(currentPhotoIndex === index) ? 'photo-container' : 'photo-hidden'">
                <img :src="photo.url" class="fullscreen-photo">
            </div>
        </div>

        <div v-if="rotationInStartState" class="caption-container">
            Yell STOP! to pick a photo.
        </div>
    </div>

</template>

<script>
import constants from '../../../photo-prov-shared/lib/classes/constants.mjs';
import QRCode from '../../../photo-prov-shared/lib/components/QRCode.vue';

export default {
    name: 'PresenterPanel',
    components: {
        QRCode
    },
    props: {
        authToken: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            statePollingInterval: null,
            currentDisplayState: null,
            currentPhotoRotationState: null,
            currentCharacterPhotosOnlyState: false,
            currentPracticeMode: true,
            currentShowId: null,
            currentShowObj: null,
            forcedPhotoUrl: null,
            showDescription: null,
            photos: [],
            currentPhotoIndex: 0,
            viewedPhotos: [],
            displayQRCode: false,
            fullScreenMode: false,
        }
    },
    watch: {
        currentDisplayState(newValue, oldValue) {
            // debug... 
            console.log(`currentDisplayState changed from ${oldValue} to ${newValue}`);
            if (newValue === constants.PRESENTER_DISPLAY_STATES.PHOTO_SELECT) {
                // when we've switched to pre-show displaying QR code to photo rotation,
                // load all the photos from show data
                this.loadShowPhotoImages();
            }
        },
        currentPhotoRotationState(newValue, oldValue) {
            // debug... 
            console.log(`currentPhotoRotationState changed from ${oldValue} to ${newValue}`);
        },
        currentPracticeMode(newValue, oldValue) {
            // debug... 
            console.log(`currentPracticeMode changed from ${oldValue} to ${newValue}`);
        },
        currentCharacterPhotosOnlyState(newValue, oldValue) {
            // debug... 
            console.log(`currentCharacterPhotosOnlyState changed from ${oldValue} to ${newValue}`);
            // what photos to display has changed... load all the photos from show data
            // bug? prevent photos from getting hidden when switching character only mode - reset current photo index
            // this.currentPhotoIndex = 0;
            this.loadShowPhotoImages();
        },
        currentShowId(newValue, oldValue) {
            // debug... 
            console.log(`currentShowId changed from ${oldValue} to ${newValue}`);
            if (this.currentShowId !== 'null') {
                this.loadShowPhotoImages();
            }
        },
    },
    created() {
        // when first initialized, set the current state to the pre-show screen.
        localStorage.setItem(constants.PRESENTER_DISPLAY_STATE_KEY, constants.PRESENTER_DISPLAY_STATES.PRE_SHOW);
        // always reset photo rotation state in case presenter screen is getting re-initialized
        localStorage.setItem(constants.PRESENTER_ROTATION_STATE_KEY, constants.PHOTO_ROTATION_STATES.RESET);

        this.currentShowObj = null;
        this.showDescription = null;
        this.displayQRCode = false;
        this.currentShowId = null;
        this.fullScreenMode = false;

        this.statePollingInterval = setInterval(() => {

            this.currentDisplayState = localStorage.getItem(constants.PRESENTER_DISPLAY_STATE_KEY);
            this.currentPhotoRotationState = localStorage.getItem(constants.PRESENTER_ROTATION_STATE_KEY);
            this.currentPracticeMode = localStorage.getItem(constants.PRESENTER_PRACTICE_MODE_KEY);
            this.currentCharacterPhotosOnlyState = localStorage.getItem(constants.PRESENTER_CHARACTER_PHOTOS_ONLY_KEY);
            this.currentShowId = localStorage.getItem(constants.PRESENTER_SELECTED_SHOW_KEY);
            this.showDescription = localStorage.getItem(constants.PRESENTER_SHOW_DESC_KEY);
            this.forcedPhotoUrl = localStorage.getItem(constants.PRESENTER_FORCED_URL_KEY);

            const tmp = JSON.stringify(this.viewedPhotos.map(item => item.url));
            localStorage.setItem(constants.PRESENTER_VIEWED_PHOTOS_KEY, tmp);

            // Rotate current photo if photo rotation enabled
            if (this.currentPhotoRotationState === constants.PHOTO_ROTATION_STATES.STARTED) {
                if (this.currentPhotoIndex == this.photos.length - 1) {
                    // remove images that have been displayed (used in performance)
                    this.photos = this.photos.filter(photo => (photo.approvalState !== constants.PHOTO_APPROVAL_STATES.USED_IN_PERFORMANCE))

                    // randomize the list of photos so they are shown in a different order each time
                    this.photos.sort(() => Math.random() - 0.5);
                    this.currentPhotoIndex = 0;
                }
                else {
                    this.currentPhotoIndex++;
                }

                if (this.currentPhotoIndex >= this.photos.length) {
                    this.currentPhotoIndex = 0;
                }
                // debug... console.log(`currentPhotoIndex: ${this.currentPhotoIndex} of ${this.photos.length}`);
            }

            // Mark current photo as USED_IN_PERFORMANCE if photo rotation is stopped
            if (this.currentPhotoRotationState === constants.PHOTO_ROTATION_STATES.STOPPED) {
                const currentPhoto = this.photos[this.currentPhotoIndex];
                if (currentPhoto !== undefined) {
                    // only need to change photo state once (i.e., don't set state hundreds of times)
                    if (currentPhoto.approvalState !== constants.PHOTO_APPROVAL_STATES.USED_IN_PERFORMANCE) {
                        currentPhoto.approvalState = constants.PHOTO_APPROVAL_STATES.USED_IN_PERFORMANCE;

                        // only mark photos as USED_IN_PERF when not in demo mode
                        if (this.currentPracticeMode === 'false') {
                            // call API to update photo state -- note: this is an async method so it's fire and forget
                            this.setPhotoStateToUsedInPerformance(currentPhoto.id);
                        }
                    }
                    // add current photo to viewed photos list
                    if (this.viewedPhotos.find(item => item.id === currentPhoto.id) === undefined) {
                        this.viewedPhotos.push(currentPhoto);
                    }
                }
            }

        }, 450); // timer interval in milliseconds
    },
    computed: {
        panelPreShowView() {
            return this.currentDisplayState === constants.PRESENTER_DISPLAY_STATES.PRE_SHOW;
        },
        panelPhotoSelectView() {
            return this.currentDisplayState === constants.PRESENTER_DISPLAY_STATES.PHOTO_SELECT;
        },
        panelForcedImageView() {
            return this.currentDisplayState === constants.PRESENTER_DISPLAY_STATES.FORCE_IMAGE;
        },
        rotationInResetState() {
            return this.currentPhotoRotationState === constants.PHOTO_ROTATION_STATES.RESET;
        },
        rotationInStartState() {
            return this.currentPhotoRotationState === constants.PHOTO_ROTATION_STATES.STARTED;
        },
    },
    mounted() {
        document.addEventListener('fullscreenchange', this.onFullscreenChange);
    },
    beforeUnmount() {
        document.removeEventListener('fullscreenchange', this.onFullscreenChange);
    },
    methods: {
        onFullscreenChange() {
            this.fullScreenMode = document.fullscreenElement !== null;
            if (this.fullScreenMode) {
                document.documentElement.style.overflow = 'hidden';
            } else {
                document.documentElement.style.overflow = 'auto';
            }
        },
        goFullscreen() {
            const elem = document.documentElement;
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            }
        },
        async setPhotoStateToUsedInPerformance(photoId) {
            console.log(`setting photoId ${photoId} state to USED_IN_PERFORMANCE`);

            //========================================================================
            // call private API to set photo state
            //========================================================================
            const apiEndpoint = process.env.VUE_APP_PRV_API + '/photoState';
            try {
                const response = await fetch(apiEndpoint, {
                    method: 'PUT',
                    headers: {
                        'Authorization': `Bearer ${this.authToken}`,
                    },
                    body: JSON.stringify({
                        photoIds: [photoId],
                        approvalState: constants.PHOTO_APPROVAL_STATES.USED_IN_PERFORMANCE
                    }),
                });

                if (!response.ok) {
                    // Handle HTTP errors (e.g., 4xx, 5xx)
                    const errorText = await response.text(); // Get error details if available
                    console.error('Fetch error:', response.status, errorText);
                    throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
                }
            } catch (error) {
                console.error('Error setting photo state:', error);
            }

        },
        async loadShowPhotoImages() {
            //========================================================================
            // call private API to get show data including list of images.
            //========================================================================
            const apiEndpoint = process.env.VUE_APP_PRV_API + '/showdata?showId=' + this.currentShowId;

            try {
                const response = await fetch(apiEndpoint, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${this.authToken}`,
                    }
                });

                if (!response.ok) {
                    const errorText = await response.text();
                    console.error('Fetch error:', response.status, errorText);
                    throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
                }

                this.currentShowObj = await response.json(); // Parse the JSON response body
                // debug... console.log(`currentShowObj:\n`, this.currentShowObj);

                // now that currentShowObj is set (containing audience app url), QR Code can be displayed
                this.displayQRCode = true;

                this.photos = this.currentShowObj.approvedPhotos;
                // debug... console.log(`received ${this.photos.length} approved photos from server`);

                // in "Act 2" of the show, character monologues are done using character photos filter as needed.
                if (this.currentCharacterPhotosOnlyState === 'true') {
                    this.photos = this.photos.filter(photo => photo.isCharacterPhoto);
                }
                // debug...
                console.log(`received ${this.photos.length} photos from server`)

            } catch (error) {
                // Handle network errors or errors during fetch/parsing
                console.error('Error fetching data:', error);
                // TODO: how to display errors in the full screen presenter window?
                // maybe draw a red square (border color) around the window container element to indicate there's a problem?
                // error message could also be shared with the Control Panel and could be displayed there?
                // this.errorMsg = 'Error getting data from server';
            }


        }
    }

};
</script>

<style scoped>
.presenter-panel {
    border: 0px solid purple;
    padding: 10px;
    text-align: center;
}

.photo-hidden,
.photo-container {
    position: fixed;
    top: 0;
    left: 0;
    /* 100% of viewport width */
    width: 100vw;
    /* 100% of viewport height */
    height: 90vh;
    padding: 10px;
    /* #121212 matches Vuetify dark theme */
    background-color: #121212;
    justify-content: center;
    align-items: center;
}

.photo-hidden {
    display: none;
}

.photo-container {
    display: flex;
}

.caption-container {
    position: fixed;
    top: 90vh;
    left: 0;
    /* 100% of viewport width */
    width: 100vw;
    /* 100% of viewport height */
    height: 10vh;
    padding: 0;

    text-align: center;
    /* #121212 matches Vuetify dark theme */
    background-color: #121212;
}

.rotation-qmarks-div {
    width: 95%;
    height: 95%;
    object-fit: contain;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.logoText {
    border: 0px solid orange;
    border-radius: 10px;
    background-color: yellow;
    color: black;
    padding-left: 10px;
    padding-right: 10px;
    font-size: 30px;
}

.fullscreen-photo {
    width: 95%;
    height: 95%;
    object-fit: contain;
}
</style>